import { Button, Menu, MenuItem, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function LanguageToggle() {
    const { i18n } = useTranslation();
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (language) => {
        i18n.changeLanguage(language);
        localStorage.setItem('i18nextLng', language);
        handleClose();
    };

    const currentLanguage = i18n.language || 'en';
    const languageLabel = currentLanguage === 'am' ? 'አማ' : 'EN';

    return (
        <>
            <Button
                onClick={handleClick}
                sx={{
                    color: theme.palette.primary.main,
                    textTransform: 'none',
                    minWidth: 'auto',
                    px: 1.5,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    }
                }}
                startIcon={<LanguageIcon />}
                endIcon={<ArrowDropDownIcon />}
            >
                {languageLabel}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem 
                    onClick={() => handleLanguageChange('en')}
                    selected={currentLanguage === 'en'}
                >
                    English
                </MenuItem>
                <MenuItem 
                    onClick={() => handleLanguageChange('am')}
                    selected={currentLanguage === 'am'}
                >
                    አማርኛ
                </MenuItem>
            </Menu>
        </>
    );
}

export default LanguageToggle;

